module.exports = __webpack_public_path__ + "img/avatar-3.c59fba36.png";